import "./Article.scss";

class Page {

	/**
	 * @arg {object} opts — Options
	 * @constructor
	 */
	constructor(opts = {}) {

	}
	
	/** Need this to run after DOM ready? Put scripts here */

	// TODO: change to onMount
	init() {
		
	}
}

window.Zero = window.Zero || {};
window.Zero.page = new Page();